module.exports = __webpack_public_path__ + "img/logo-j.a14b1053.svg";